import React from 'react';

const LoadingScreen = ({ progress = { current: 0, total: 100, articles: 0 }, status = 'Cargando...' }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: 'linear-gradient(135deg, #e62c19 0%, #a01916 100%)',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{
        background: 'rgba(255,255,255,0.95)',
        padding: '40px',
        borderRadius: '20px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
        textAlign: 'center',
        maxWidth: '320px',
        backdropFilter: 'blur(10px)'
      }}>
        {/* Logo animado */}
        <div style={{
          marginBottom: '30px',
          animation: 'pulse 2s ease-in-out infinite'
        }}>
          <img 
            src="/assets/logo-agustinos.png" 
            alt="Agustinos" 
            style={{
              height: '80px',
              width: 'auto',
              filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.1))'
            }}
          />
        </div>
        
        {/* Spinner elegante */}
        <div style={{
          width: '40px',
          height: '40px',
          border: '3px solid #f3f3f3',
          borderTop: '3px solid #e62c19',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 20px'
        }}></div>
        
        <p style={{margin: '0', color: '#333', fontWeight: '600'}}>
          Cargando contenido...
        </p>
        <p style={{margin: '10px 0 0', color: '#666', fontSize: '14px'}}>
          {progress.articles > 0 ? `${progress.articles} artículos` : 'Conectando...'}
        </p>
      </div>

      {/* CSS para animaciones */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.05); opacity: 0.8; }
        }
      `}</style>
    </div>
  );
};

export default LoadingScreen;